import type { ScheduleFile } from '../data/types';

const WEEKDAYS = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'] as const;

export function berlinParts(date: Date) {
  const fmt = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Europe/Berlin',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    weekday: 'long',
    hour12: false,
  });
  const parts = fmt.formatToParts(date);
  const get = (t: string) => parts.find((p) => p.type === t)?.value ?? '';
  return {
    dateStr: `${get('year')}${get('month')}${get('day')}`,
    weekday: get('weekday').toLowerCase(),
    hour: Number(get('hour')),
    minute: Number(get('minute')),
    second: Number(get('second')),
  };
}

export function serviceActiveOn(
  schedule: ScheduleFile,
  serviceId: string,
  dateStr: string,
  weekday: string,
): boolean {
  const exceptions = schedule.calendarDates.filter((c) => c.serviceId === serviceId && c.date === dateStr);
  const cal = schedule.calendar.find((c) => c.service_id === serviceId);
  let active = false;
  if (cal && dateStr >= cal.start_date && dateStr <= cal.end_date) {
    active = cal[weekday as keyof typeof cal] === '1';
  }
  for (const ex of exceptions) {
    if (ex.exception === '1') active = true;
    else if (ex.exception === '2') active = false;
  }
  return active;
}

export function activeServices(schedule: ScheduleFile, date: Date): Set<string> {
  const { dateStr, weekday } = berlinParts(date);
  const ids = new Set<string>();
  for (const t of schedule.trips) ids.add(t.serviceId);
  const out = new Set<string>();
  for (const id of ids) if (serviceActiveOn(schedule, id, dateStr, weekday)) out.add(id);
  return out;
}
